// extracted by mini-css-extract-plugin
module.exports = {"tablet":"Tablet_tablet_X2taf","professor":"Tablet_professor_FQVQ7"};